import reframe, { parametric, pathSubscription, subscription } from 'nike-re-framejs';
import Immutable from 'immutable';
import * as boxFn from './domain';
import { isTodaySlugVisible } from './components/TodayOffer';
import { isSuperkurzySlugVisible } from './components/Superkurzy';
import { DEFAULT_INTERVAL } from './components/dialog/byDate';

reframe.regSub('nikeone/filter', (db, [_, boxStore]) =>
    db.getIn(
        ['nikeone', 'boxStore', boxStore || 'filteredBoxStore', 'filter'],
        Immutable.Map({ byDate: DEFAULT_INTERVAL })
    )
);

reframe.regSub('nikeone/boxes', (db, [_, boxStore]) =>
    db.getIn(['nikeone', 'boxStore', boxStore, 'boxes'], Immutable.Map())
);

reframe.regSub('nikeone/box', (db, [_, boxStore, boxId]) =>
    db.getIn(['nikeone', 'boxStore', boxStore, 'boxes', boxId], Immutable.Map())
);

reframe.regSub('nikeone/sportEvents', (db, [_, boxStore]) =>
    db.getIn(['nikeone', 'boxStore', boxStore, 'sportEvents'], Immutable.Map())
);

export const nike1SportEvent$ = parametric((boxStore, sportEventId) =>
    subscription(db => db.getIn(['nikeone', 'boxStore', boxStore, 'sportEvents', sportEventId]))
);

reframe.regSub('nikeone/market', (db, [_, boxStore, marketId]) =>
    db.getIn(['nikeone', 'boxStore', boxStore, 'markets', marketId], Immutable.Map())
);

export const nike1Bet$ = parametric((boxStore, betId) =>
    subscription(db => db.getIn(['nikeone', 'boxStore', boxStore, 'bets', String(betId)]))
);

export const matchesOnTickets$ = parametric(boxStore =>
    subscription(db => db.getIn(['nikeone', 'boxStore', boxStore, 'boxes', 'onTicketsBoxId', 'liveSportEventIds']))
);

function regFilterSub(subscriptionId, handler) {
    reframe.regSub(subscriptionId, ([_, boxStore]) => reframe.subscribe(['nikeone/filter', boxStore]), handler);
}

function regBoxSub(subscriptionId, handler) {
    reframe.regSub(
        subscriptionId,
        ([_, boxStore, boxId]) => reframe.subscribe(['nikeone/box', boxStore, boxId]),
        handler
    );
}

regBoxSub('nikeone/box/getBoxMarketStatus', boxFn.boxMarketStatus);

regBoxSub('nikeone/box/isShowMarkets', boxFn.isShowMarkets);

regBoxSub('nikeone/box/prematchHierarchy', boxFn.getPrematchHierarchy);

regBoxSub('nikeone/box/resultBetsHierarchy', boxFn.getResultBetsHierarchy);

regBoxSub('nikeone/box/isEmpty', boxFn.isEmpty);

regBoxSub('nikeone/box/hasNoSection', boxFn.hasNoSection);

regBoxSub('nikeone/box/firstSportEventId', box => box.getIn(['sportEventIds', 0]));

regBoxSub('nikeone/box/marketShortcutIds', box => box.getIn(['marketHierarchy', 'shortcut']));

regBoxSub('nikeone/box/selectedMarketIds', box => box.getIn(['selectedMarketIds']));

regBoxSub('nikeone/box/title', box => box.getIn(['title']));

regBoxSub('nikeone/box/betIds', box => box.getIn(['betIds'], Immutable.List()));

regFilterSub('nikeone/filter/byDate', filter => filter.get('byDate'));

regFilterSub('nikeone/filter/isPrematchOnly', filter => !filter.getIn(['offer', 'live']));

regFilterSub('nikeone/filter/isTournamentExpanded', (filter, [_, , boxId]) => filter.getIn(['boxIds', boxId]));

reframe.regSub('nikeone.slider.visible.today', () => reframe.subscribe(['nikeone/filter/byDate']), isTodaySlugVisible);

reframe.regSub(
    'nikeone.slider.visible.superkurzy',
    () => reframe.subscribe(['nikeone/filter/byDate']),
    isSuperkurzySlugVisible
);

export const nike1BetExtras = parametric((boxStore, betId) =>
    subscription(bet => bet?.getIn(['extras'], Immutable.List()), nike1Bet$(boxStore, betId))
);

export const nike1EditorTipByBetId$ = (boxStore, betId) =>
    pathSubscription(['nikeone', 'boxStore', boxStore, 'editorTips', betId]);

// loading
reframe.regSub('nikeone/loading/box', (db, [_, boxId]) => db.getIn(['nikeone', 'loading', 'box', boxId]));

reframe.regSub(
    'nikeone/loading/box/done',
    ([_, boxId]) => reframe.subscribe(['nikeone/loading/box', boxId]),
    state => state === false
);
reframe.regSub(
    'nikeone/loading/box/pending',
    ([_, boxId]) => reframe.subscribe(['nikeone/loading/box', boxId]),
    state => state === true
);
reframe.regSub('nikeone/loading/market', (db, [_, boxId]) => db.getIn(['nikeone', 'loading', 'market', boxId]));

export const postsCount$ = pathSubscription(['nikeone', 'detail', 'postsCount']);

reframe.regSub('nikeone/detail/discussionPostsCount', db => db.getIn(['betbook', 'detail', 'commentCount']));

reframe.regSub('nikeone/matchCountOnTickets', (db, [_, boxStore, box]) =>
    db.getIn(['nikeone', 'boxStore', boxStore, 'boxes', box, 'sportEventIds'], Immutable.List()).count()
);
